import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';
import { IManualEventOverrides } from '@faire/web/common/pete/types';

export const eventKey = 'seo-browser_id_tracker-action_category_pageload';

/**
 * Track a retailer/visitor's browser ID. This is a randomly generated UUID and stored as a cookie.
 */
export function trackSeoBrowserIdTrackerActionCategoryPageload(
  Browser_ID: string,
  Browser_Name2: string = '',
  Browser_Version3: string = '',
  OS_Name4: string = '',
  OS_Version5: string = '',
  Device_Type6: string = '',
  manualOverrides?: IManualEventOverrides
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    manualOverrides,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: {
      Browser_ID,
      Browser_Name2,
      Browser_Version3,
      OS_Name4,
      OS_Version5,
      Device_Type6,
    },
  });
}
